import { Checkbox } from '@material-ui/core'
import React, { useEffect, useState } from 'react'

const CheckPaid = ({ props, handleChangePaid, field, deselect, icon, checkedIcon , select}) => {
    const payed = props && props[field] ? parseInt(props[field]) === 1 : false
    const [checked, setChecked] = useState(payed)

    useEffect(() => {
        setChecked(payed)
    }, [payed])

    useEffect(() => {
        if (deselect) {
            setChecked(false)
        }
    }, [deselect])

    useEffect(() => {
        if (select) {
            setChecked(true)
        }
    }, [select])

    const handleChange = event => {
        setChecked(event.target.checked)
        handleChangePaid(props, event.target.checked ? 1 : 0)
    }

    return (
        <div>
            <Checkbox
                checked={checked}
                onChange={handleChange}
                color="primary"
                inputProps={{ 'aria-label': 'primary checkbox' }}
                icon={icon}
                checkedIcon={checkedIcon}
            />
        </div>
    )
}

export default CheckPaid